'use client'

import { useAuthStore } from '@/stores/useAuthStore'
import { useCartStore } from '@/stores/useCartStore'
import { useZipCodeStore } from '@/stores/useZipCodeStore'
import { normalizeZipCode } from '~/schemas/customer/address'

/**
 * CEP do último frete calculado pelo visitante (`useZipCodeStore`, gravada pelos services de frete); sem ele, o do
 * carrinho (cotado antes de existir a store, ou restaurado pela sessão). Só dígitos.
 */
function useLastQuotedZipCode(): string {
    const stored = useZipCodeStore((state) => state.zipCode)
    const cartZipCode = useCartStore((state) => state.data?.cep)
    return stored || normalizeZipCode(cartZipCode ?? '')
}

const useStoredAddresses = () => useAuthStore((state) => state.data?.customer?.addresses)

/**
 * CEP para preencher um campo de frete (PDP, carrinho), sem calcular: o do último frete; sem ele, o do endereço
 * principal do cliente logado; sem principal, o do primeiro endereço; sem nada, vazio. Só dígitos.
 */
export function usePreferredZipCode(): string {
    const lastQuoted = useLastQuotedZipCode()
    const addresses = useStoredAddresses()
    if (lastQuoted) return lastQuoted
    const address = addresses?.find((item) => item.defaultAddress) ?? addresses?.[0]
    return address ? normalizeZipCode(address.zipCode) : ''
}

/**
 * CEP para começar um cadastro de endereço (checkout e perfil): o do último frete, desde que ainda não seja de um
 * endereço salvo do cliente (nesse caso ele escolhe o salvo). Sem frete calculado, vazio. Só dígitos.
 */
export function useNewAddressZipCode(): string {
    const lastQuoted = useLastQuotedZipCode()
    const addresses = useStoredAddresses()
    if (!lastQuoted) return ''
    const saved = addresses?.some((address) => normalizeZipCode(address.zipCode) === lastQuoted)
    return saved ? '' : lastQuoted
}
